import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommissioningStore } from '@store';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { CodeScannerService } from '../../../../../../../shared/services';
import { CodeScannerResponseType } from '../../../../../../../shared/services/code-scanner.model';
import { ModalAction } from '../../../commissioning.model';
import { CommissioningService } from '../../../commissioning.service';

@Component({
  selector: 'app-commissioning-scan-code',
  templateUrl: './commissioning-scan-code.component.html',
  styleUrls: ['./commissioning-scan-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissioningScanCodeComponent implements OnInit, OnDestroy {
  readonly qrCodeRegex = new RegExp(/[\/|:](\w{16})(\S*[\/|:])(\w{36})/);

  @Output() localModalAction = new EventEmitter<ModalAction>();
  @Output() openCodeFormAction = new EventEmitter<void>();

  currentCode = {
    id: null,
    ic: null,
  };

  isError = false;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public codeScannerService: CodeScannerService,
    public commissioningService: CommissioningService,
    private commissioningStore: CommissioningStore,
    private dialogRef: MatDialogRef<CommissioningScanCodeComponent>
  ) {}

  ngOnInit(): void {
    this.dialogRef.updateSize('768px');
    this.dialogRef.addPanelClass('commissioning-modal');
    this.commissioningStore.currentCode$
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        map((code) => code || { id: null, ic: null })
      )
      .subscribe((code) => {
        this.currentCode = {
          id: code.id,
          ic: code.ic,
        };
      });
  }

  openScanner(): void {
    this.codeScannerService
      .openCodeDialog()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((response) => {
        switch (response.type) {
          case CodeScannerResponseType.CODE_SCANNER_MANUAL_INPUT_REQUEST:
            this.openCodeFormAction.next();
            break;
          case CodeScannerResponseType.CODE_SCANNER_RESULT:
            this.parseQRCode(response.value);
            break;
        }
      });
  }

  navigateBack(): void {
    this.commissioningStore.setCode({
      ic: '',
      id: '',
    });
    this.localModalAction.emit(ModalAction.PreviousStep);
  }

  openCodeForm(): void {
    this.openCodeFormAction.next();
  }

  navigateForward(): void {
    const code = {
      id: this.currentCode.id,
      ic: this.currentCode.ic,
    };
    this.commissioningStore.setCode(code);
    this.localModalAction.emit(ModalAction.NextStep);
  }

  closeDialog(): void {
    this.commissioningService.modalAction$.next(ModalAction.Close);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  private parseQRCode(code: string): void {
    const strippedCode = code.replace(/\s/g, '');
    try {
      const [_input, id, _separator, ic] = this.qrCodeRegex.exec(strippedCode);

      this.currentCode = {
        id,
        ic,
      };
      this.navigateForward();
    } catch {
      this.isError = true;
    }
  }
}
